<template>
  <div class="loan-content">
    <h2 class="table-title">Thông tin tổng quan</h2>
    <div
      class="loan-table hidden sm:hidden md:hidden lg:block"
    >
      <table class="table-auto">
        <thead>
        <tr>
          <th class="px-4 py-2">
            Số hợp đồng
          </th>
          <th class="px-4 py-2">
            Biển số xe
          </th>
          <th class="px-4 py-2">
            Ngày hiệu lực<br />
            hợp đồng
          </th>
          <th class="px-4 py-2">
            Ngày kết thúc<br />
            hợp đồng
          </th>
          <th class="px-4 py-2">
            Số tiền vay (VND)
          </th>
          <th class="px-4 py-2">
            Dư nợ còn lại (VND)
          </th>
        </tr>
        </thead>
        <DataBox use-in="table" :loading="loading" :isEmpty="isEmpty" :error="error">
          <router-link v-for="(item, index) in contracts" :key="index" :to="{ name: 'loanDetail', params: {contractNo: item.ContractNo}}" tag="tr" >
            <td class="px-4 py-2">
              {{item.ContractNo}}
            </td>
            <td class="px-4 py-2">
              {{item.PlateNo}}
            </td>
            <td class="px-4 py-2" v-if="item.ContractDateStart && item.ContractDateStart !== null">
              {{ item.ContractDateStart | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
            </td>
            <td class="px-4 py-2" v-else>
            </td>
            <td class="px-4 py-2" v-if="item.ContractDateEnd && item.ContractDateEnd !== null">
              {{ item.ContractDateEnd | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
            </td>
            <td class="px-4 py-2" v-else>
            </td>
            <td class="px-4 py-2">
              {{Number(item.ContractAmount).toLocaleString()}}
            </td>
            <td class="px-4 py-2">
              {{Number(item.ContractAmountOutstanding).toLocaleString()}}
            </td>
            <td class="px-4 py-2">
              <button class="loan-button" @click.prevent="makeContract(item.ContractNo)">
                <i>
                  <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke-width="1" fill="none" fill-rule="evenodd" stroke="currentColor"> <g transform="translate(-7.000000, -12.000000)"> <g transform="translate(8.000000, 13.000000)"> <polyline stroke-width="1.05263158" points="4.21052632 7.89473684 6.31578947 10 8.42105263 7.89473684"></polyline> <line x1="6.31578947" y1="5.26315789" x2="6.31578947" y2="10" stroke-width="1.05263158"></line> <path d="M10.9894737,8.46842107 L10.9894737,8.46842107 C12.1783421,7.63241054 12.4643842,5.99092633 11.6283737,4.80205791 C11.135151,4.10065791 10.3311368,3.68354212 9.47368419,3.68421054 L8.81052629,3.68421054 L8.81052629,3.68421054 C8.23256313,1.43176843 5.93806313,0.0743421175 3.68562629,0.652305275 C1.43318418,1.23026843 0.0757578682,3.52476843 0.653721026,5.77720528 C0.819581026,6.42359475 1.13670576,7.02130001 1.57894734,7.52104738" stroke-width="1.05263158"></path> </g> </g> </g> </svg>
                </i>
                Tải hợp đồng
              </button>
            </td>
          </router-link>
        </DataBox>
      </table>
    </div>
    <div
      class="loan-contract block sm:block md:block lg:hidden"
    >
      <ul class="contract-list">
        <router-link class="contract-item" v-for="(item, index) in contracts" :key="index" :to="{ name: 'loanDetail', params: {contractNo: item.ContractNo}}" tag="li" >
          <p class="contract-text">Số hợp đồng</p>
          <p class="contract-number">
            {{item.ContractNo}}
          </p>
          <div class="flex flex-wrap">
            <div class="w-2/4">
              <p class="contract-text">
                Biển số xe
              </p>
              <p class="contract-value">
                {{item.PlateNo}}
              </p>
            </div>
            <div class="w-2/4">
            </div>
            <hr />
            <div class="w-2/4">
              <p class="contract-text">
                Bắt đầu hợp đồng
              </p>
              <p class="contract-value" v-if="item.ContractDateStart && item.ContractDateStart !== null">
                {{ item.ContractDateStart | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
              </p>
              <p class="contract-value" v-else>
              </p>
            </div>
            <div class="w-2/4">
              <p class="contract-text">
                Kết thúc hợp đồng
              </p>
              <p class="contract-value" v-if="item.ContractDateEnd && item.ContractDateEnd !== null">
                {{ item.ContractDateEnd | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
              </p>
              <p class="contract-value" v-else>
              </p>
            </div>
            <hr />
            <div class="w-2/4">
              <p class="contract-text">
                Số tiền vay (VND)
              </p>
              <p class="contract-value">
                {{Number(item.ContractAmount).toLocaleString()}}
              </p>
            </div>
            <div class="w-2/4">
              <p class="contract-text">
                Dư nợ còn lại (VND)
              </p>
              <p class="contract-value">
                {{Number(item.ContractAmountOutstanding).toLocaleString()}}
              </p>
            </div>
            <div class="w-full">
              <button class="loan-button" @click.prevent="makeContract(item.ContractNo)">
                <i>
                  <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g stroke-width="1" fill="none" fill-rule="evenodd" stroke="currentColor"> <g transform="translate(-7.000000, -12.000000)"> <g transform="translate(8.000000, 13.000000)"> <polyline stroke-width="1.05263158" points="4.21052632 7.89473684 6.31578947 10 8.42105263 7.89473684"></polyline> <line x1="6.31578947" y1="5.26315789" x2="6.31578947" y2="10" stroke-width="1.05263158"></line> <path d="M10.9894737,8.46842107 L10.9894737,8.46842107 C12.1783421,7.63241054 12.4643842,5.99092633 11.6283737,4.80205791 C11.135151,4.10065791 10.3311368,3.68354212 9.47368419,3.68421054 L8.81052629,3.68421054 L8.81052629,3.68421054 C8.23256313,1.43176843 5.93806313,0.0743421175 3.68562629,0.652305275 C1.43318418,1.23026843 0.0757578682,3.52476843 0.653721026,5.77720528 C0.819581026,6.42359475 1.13670576,7.02130001 1.57894734,7.52104738" stroke-width="1.05263158"></path> </g> </g> </g> </svg>
                </i>
                Tải hợp đồng
              </button>
            </div>
          </div>
        </router-link>
      </ul>
    </div>
    <paginate
      :pageCount="pageCount"
      :containerClass="'pagination'"
      :prev-text="'<i class=&quot;iconvl icon-angle-left&quot;></i>'"
      :next-text="'<i class=&quot;iconvl icon-angle-right&quot;></i>'"
      :clickHandler="paginateCallback">
    </paginate>
    <UiModal closeOnOverlay :show.sync="isShownModal">
      <div class="modal-container modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 overflow-y-auto">
        <div class="modal-content text-left">
      <!--Title-->
      <div class="modal-header bg-danger text-white">
        <p class="modal-title">
          Các thông báo bạn đã bỏ lỡ
        </p>
      </div>
      <!--Body-->
      <PersonalNotification/>
      <!--Footer-->
      <div class="modal-footer">
        <button class="modal-close px-4 p-3" @click="submitModalHandler">
          OK
        </button>
      </div>
      </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'

import DataBox from '../../components/DataBox'
import Paginate from 'vuejs-paginate'
import UiModal from '@/components/UiModal.vue'
import PersonalNotification from './includes/PersonalNotification'
import { ContractsService } from '@/services/contracts.service'
// import { NotificationsService } from '@/services/notifications.service'

export default {
  name: 'LoanSummary',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  components: {
    DataBox,
    Paginate,
    UiModal,
    PersonalNotification
  },
  data () {
    return {
      isShownModal: false
    }
  },
  props: {
    limit: { type: Number },
    page: { type: Number }
  },
  watch: {
    'pagination.limit': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    'pagination.page': function () {
      this.$router.replace({
        query: this.useInUrlQueryPropList
      })
      this.fetchData()
    },
    limit: {
      handler: function (newVal) {
        this.$store.commit('contracts/SET_PAGINATION', { limit: newVal })
      },
      immediate: true
    },
    page: {
      handler: function (newVal) {
        this.$store.commit('contracts/SET_PAGINATION', { page: newVal })
      },
      immediate: true
    }
  },
  methods: {
    fetchData () {
      this.$store.dispatch('contracts/getListPublic', { params: this.fetchParams })
    },
    paginateCallback: function (page) {
      this.$store.commit('contracts/SET_PAGINATION', { page: page })
      this.fetchData()
    },
    submitModalHandler () {
      this.isShownModal = false
    },
    makeContract (contractNo) {
      return ContractsService.makeContractPdf(contractNo)
    },
    goTo (url) {
      // window.location.href = url
      window.open(url)
    }
  },

  computed: {
    ...mapState('contracts', {
      contracts: 'items',
      pagination: 'pagination',
      error: 'error',
      loading: 'loading'
    }),
    ...mapGetters('contracts', [
      'isEmpty'
    ]),
    ...mapState('unreadNotifications', {
      unreadNotifications: 'items'
    }),
    useInUrlQueryPropList () {
      return this.prepareQueryParamsMixin({
        limit: this.pagination.limit,
        page: this.pagination.page
      })
    },
    fetchParams () {
      const pagination = this.prepareFetchParamsMixin({
        limit: this.pagination.limit,
        pageIndex: this.pagination.page
      })

      return { ...pagination }
    },
    pageCount () {
      return Math.ceil(this.pagination.total / this.pagination.limit)
    }
  },

  created () {
    this.fetchData()
  },
  mounted () {
    if (localStorage.getItem('wasVisited') === null) {
      this.$store.dispatch('unreadNotifications/getListPublic', { params: { pageIndex: 1, isRead: false } })
        .then(resp => {
          if (resp.data.total > 0) {
            this.isShownModal = true
            localStorage.setItem('wasVisited', 1)
          }
        })
    }
    /* if (localStorage.getItem('wasVisited') === null) {
      NotificationsService.getListPublic({ pageIndex: 1, pageSize: 5, isRead: false })
        .then(response => {
          if (response.data.total > 0) {
            this.$nextTick(() => {
              this.isShownModal = true
              localStorage.setItem('wasVisited', 1)
            })
          }
        })
        .catch(error => console.log(error.message))
    } */
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/components/_loanButton.scss';
</style>
